import React from 'react';
import cx from 'classnames';

/**
 * Tile Component.
 */
interface IInputTitle {
  /** Passed down classname. */
  className?: string;
  /** If background has a solid color */
  isReverse?: boolean;
  /** Is small */
  isSmall?: boolean;
  /** Optional title */
  title?: string;
}

export const InputTitle: React.FC<IInputTitle> = ({
  className,
  isSmall = false,
  isReverse = false,
  title,
}) => {
  const combinedLabelClass =
    !!title &&
    cx({
      'panda-input-title': !isReverse,
      'panda-input-title--large': !isSmall,
      'panda-input-title--small': isSmall,
      'panda-input-title--white': isReverse,
      [className || '']: !!className,
    });

  return <label className={combinedLabelClass || ''}>{title}</label>;
};
